import CommonModal from "components/CommonModal";
import PageLoading from "components/PageLoading";
import React from "react";

export default function CommonComponents() {
  return (
    <div>
      <PageLoading />
      <CommonModal />
      <div className="font-zing" />
      <div className="font-railroad" />
      <div className="font-hwt" />
      <div className="font-mont" />
      <div className="font-teko" />
      <div className="font-body" />
    </div>
  );
}
